import { Invoice } from "../../domain/entities/Invoice"
import { InvoiceStatus } from "../../domain/enum/invoiceStatus.enum"
import { BillingRepository } from "../../domain/repositories/billingRepository"
import type { InvoicesFilter } from "../../domain/types/billing/InvoicesFilter"
import { BillingService } from "../services/BillingService"

export class BillingRepositoryImpl implements BillingRepository {
	private billingService: BillingService
	constructor({ BillingService }: { BillingService: BillingService }) {
		this.billingService = BillingService
	}

	exportInvoiceTransactions(invoiceId: number[]): Promise<Blob> {
		return this.billingService.exportInvoiceTransactions(invoiceId)
	}

	updateInvoicesStatus(
		invoiceIds: number[],
		status: InvoiceStatus,
		invoiceNumberStart?: number | null
	): Promise<void> {
		return this.billingService.updateInvoicesStatus(invoiceIds, status, invoiceNumberStart)
	}

	exportInvoices(filter: InvoicesFilter): Promise<Blob> {
		return this.billingService.exportInvoices(filter)
	}

	exportInvoicePayments(filter: InvoicesFilter): Promise<Blob> {
		return this.billingService.exportInvoicePayments(filter)
	}

	async getInvoices(filter: InvoicesFilter): Promise<Invoice[]> {
		const invoices = await this.billingService.getInvoices(filter)
		return invoices.map(i => i.toDomain())
	}

	updateTransactionCreatedDate(transactionIds: number[], createdDate: Date, invoiceId: number): Promise<void> {
		return this.billingService.updateTransactionCreatedDate(transactionIds, createdDate, invoiceId)
	}

	updateInvoice(
		invoiceId: number[],
		data: {
			emissionDate?: string
			invoiceNumber?: string
			sellerPaymentDate?: string
			sellerCollectionDate?: string
		}
	): Promise<void> {
		return this.billingService.updateInvoice(invoiceId, data)
	}
}
